const SETUP_TWO_FACTOR_PATH = "/auth/setup-2fa";

export function buildSetupTwoFactorPath(returnPath: string | null): string {
  if (returnPath === null) {
    return SETUP_TWO_FACTOR_PATH;
  }
  return `${SETUP_TWO_FACTOR_PATH}?redirect=${encodeURIComponent(returnPath)}`;
}
